export default __webpack_public_path__ + "static/media/well-done.7cd1c368.svg";